import Pikaday from 'pikaday';
import { addDays, subDays, subYears, format } from 'date-fns'

class DatePicker {

    constructor(el) {
        this.el = el;
        this.mode = this.el ? this.el.dataset.pickerMode : null;
        this.remoteDateFormat = this.el ? this.el.dataset.remoteDateFormat : null;
        this.remoteField = null;
        let rf = this.el ? this.el.dataset.remoteField : null;
        if (rf != null) {
            this.remoteField = document.querySelector(`input[id='${rf}']`);
        }
        let _this = this;
        let today = new Date();
        switch (this.mode) {
            case 'dob-adult':
            case 'dob-child':
                this.dobMinDate = this.getDobMinDate();
                this.dobMaxDate = this.getDobMaxDate();
                this.options = {
                    field: this.el,
                    firstDay: 1,
                    defaultDate: this.dobMaxDate,
                    minDate: this.dobMinDate,
                    maxDate: this.dobMaxDate,
                    yearRange: [this.dobMinDate.getFullYear(), this.dobMaxDate.getFullYear()],
                    format: 'DD/MM/YYYY',
                    onSelect: function (date) {
                        if (_this.remoteField != null) {
                            _this.remoteField.value = format(date, _this.remoteDateFormat != null ? _this.remoteDateFormat : 'DD/MM/YYYY');
                        }
                    }
                };
                break;
            case 'adoption-start':
            case 'membership-start':
                this.options = {
                    field: this.el,
                    firstDay: 1,
                    defaultDate: today,
                    minDate: today,
                    format: 'DD/MM/YYYY',
                    onSelect: function (date) {
                        if (_this.remoteField != null) {
                            _this.remoteField.value = format(date, _this.remoteDateFormat != null ? _this.remoteDateFormat : 'DD/MM/YYYY');
                        }
                    }
                };
                break;
            default:
                this.options = {
                    field: this.el,
                    firstDay: 1,
                    defaultDate: today,
                    minDate: today,
                    format: 'DD/MM/YYYY',
                    onSelect: function (date) {
                        if (_this.remoteField != null) {
                            _this.remoteField.value = format(date, _this.remoteDateFormat != null ? _this.remoteDateFormat : 'DD/MM/YYYY');
                        }
                    }
                };
                break;
        }
        this.datepicker = new Pikaday(this.options);
    }

    getDobMinDate() {
        switch (this.mode) {
            case 'dob-adult':
                return subYears(new Date(), 110);
                break;
            case 'dob-child':
                return addDays(subYears(new Date(), 18), 1);
                break;
            default:
                return new Date();
                break;
        }
    }

    getDobMaxDate() {
        switch (this.mode) {
            case 'dob-adult':
                return subYears(new Date(), 18);
                break;
            case 'dob-child':
                return subYears(new Date(), 0);
                break;
            default:
                return new Date();
                break;
        }
    }

}

// export the default function to create
export function createFrom(wrappers, validateMemberDetails, validatedCallback) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new DatePicker(node);
        }
    });
}